/**
* Sticky element
**/

;(function ($, window, _) { // eslint-disable-line no-extra-semi
    'use strict';

    /**
     * Focus component constructor
     * @param $element
     * @param target
     */
    var AnchorNav = function ($element, options) {
        this._$el = $element;
        this._options = $.extend(false, AnchorNav.config, options);
        this._dataObj= [];
        this._$targets = this._$el.find('a');
    
        this._init();
    };
    
    /*
     * Default settings
     */
    AnchorNav.config = {
        classes: {
            current: 'is--active',
            menu: 'is--navigation-open disable-scrolling'
        }  
    };

    AnchorNav.prototype._init = function() {
        var self = this;

        this._getTargets(); //getTargets

        //bind click
        this._$targets.each(function(){
            var $obj=$(this),
                target = $obj.attr('href');
            
            //bind click
            $obj.bind('click', function(e){
                if ($('body').hasClass(self._options.classes.menu))
                    $('body').removeClass(self._options.classes.menu);
                
                //check if $targets !=broken
                if(!$(target).offset())
                    return

                    $('html, body').animate({
                    scrollTop: $(target).offset().top + 5
                }, 2000);

                e.preventDefault();
            });

        });

        $(window).resize(function() {
	        if(this.resizeTO) 
	    	    clearTimeout(this.resizeTO);
	    
            this.resizeTO = setTimeout(function() {
	            $(this).trigger('resizeEnd');
            }, 500);
        });
		
		$(window).bind('resizeEnd', function() {
            self._dataObj = []; //reset dataObj
            self._getTargets(); //get new targets
            self._update(); //update meuk
		});

        $(window).scroll(_.debounce(function(){
            this._update();
        }.bind(this), 50));
        
        this._update();
    }

    AnchorNav.prototype._update = function() {
        var self=this,
            window_top = $(window).scrollTop(),
            item = _.find(self._dataObj, function(o) { return o.start <= window_top && o.end > window_top; }) ? _.find(self._dataObj, function(o) { return o.start <= window_top && o.end > window_top; }) : false ;

        $(self._$targets).removeClass(self._options.classes.current); //reset all classes

        //remove active class for section
        $.each(self._dataObj, function(index, value){
            var $obj = $(value.title);

            $obj.removeClass(self._options.classes.current);

        });

        if(item) {
            var setCurrentNav = _.find(self._$targets, function(o) { return o.hash == item.title; });

            $(setCurrentNav).addClass(self._options.classes.current); //add class 2 current menu item 
            $(item.title).addClass(self._options.classes.current); //add current section class
        }
    }

    AnchorNav.prototype._getTargets = function() {
        var self = this;

        this._$targets.each(function(){
            var $obj = $(this),
                target = $obj.attr('href');

            //_.assign(self._dataObj,getData(target));
            self._dataObj.push(getData(target));
        });

    };

    var getData = function(obj) {
        var itemArray={},
            $target = $(obj),
            title = obj,
            top = 0,
            bottom = 0;

            if(!$target.offset())
                return false

            top = $target.offset().top;
            bottom = top + $target.outerHeight();

            itemArray={'title':title,'start':top,'end':bottom};
		return itemArray;
    };

     /**
     * Attach new focus
     * @private
     */
    AnchorNav.prototype._attach = function () {
        var $el = $(this),
            options = $el.data('anchor-nav') ? $el.data('anchor-nav') : {};

        new AnchorNav($el, options);
    };


    /**
     * Attach listeners to document
     */
    $(function () {
        /**
         * Travel through the DOM for data-focus attributes
         */
        //$('[data-stricky]').each(Sticky.prototype._attach);

        /**
         * Setup a jQuery chainable plugin for attaching to injected elements after page load
         * @type {*}
         */

        $.fn.jqAnchorNav = function () {
            $(this).each(AnchorNav.prototype._attach);
        };

    });

})(jQuery, window, _);

